import { HttpLink } from '@apollo/client';
import { ApolloClient, InMemoryCache } from '@apollo/client-integration-nextjs';
import { ignoreUnresolvableLinks } from './links/ignore-unresolvable-links';

const SPACE = process.env['NEXT_PUBLIC_CONTENTFUL_SPACE_ID'] || '';
const TOKEN = process.env['CONTENTFUL_ACCESS_TOKEN'] || process.env['NEXT_PUBLIC_CONTENTFUL_ACCESS_TOKEN'] || '';
const PREVIEW_TOKEN = process.env['NEXT_PUBLIC_CONTENTFUL_PREVIEW_ACCESS_TOKEN'] || '';

const ENVIRONMENT = process.env['NEXT_PUBLIC_CONTENTFUL_ENV'] || 'master';

export const getClient = function (preview = false) {
    const url = `https://graphql.contentful.com/content/v1/spaces/${SPACE}/environments/${ENVIRONMENT}?access_token=${
        preview ? PREVIEW_TOKEN : TOKEN
    }`;

    const link = new HttpLink({
        // this needs to be an absolute url, as relative urls cannot be used in SSR
        uri: url,
        fetchOptions: {
            // you can pass additional options that should be passed to `fetch` here,
            // e.g. Next.js-related `fetch` options regarding caching and revalidation
            // see https://nextjs.org/docs/app/api-reference/functions/fetch#fetchurl-options
        },
    });

    return new ApolloClient({
        cache: new InMemoryCache(),
        link: ignoreUnresolvableLinks.concat(link),
    });
};
